import { PdButtonSelectGroup } from "./pd-button-select-group/PdButtonSelectGroup.js";
//#region src/pd-button-select-group/pd-button-select-group.ts
var tag = "pd-button-select-group";
if (!customElements.get(tag)) customElements.define(tag, PdButtonSelectGroup);
//#endregion
export { PdButtonSelectGroup };
